import {AddScoreCardLinkComponent} from '@/components/jobScorecardComponent/addScorecardLink';
import {CreateScoreStyle} from '@/imports-files/pages/clients/jobs/scorecards'

export function CreateJobAddScorecardLinkComponent(props)
{
  
  return(<div className={`${CreateScoreStyle.AddScoreLink}`}>
          <AddScoreCardLinkComponent formik = {props.formik}
                                     name = {props.name}
                                     editable = {props.editable}/>
        </div>)

}
